module.exports = __webpack_public_path__ + "img/selected1-min.b2dad04e.png";